import React from 'react';
import PropTypes from 'prop-types';
import { Message, Headline, Text } from './PlanLoaderMessage.styles';

export const PlanLoaderMessage = ({ variant = 'control', headline, text }) => (
  <Message>
    <Headline variant={variant}>{headline}</Headline>
    <Text variant={variant}>{text}</Text>
  </Message>
);
PlanLoaderMessage.displayName = 'PlanLoaderMessage';
PlanLoaderMessage.propTypes = {
  variant: PropTypes.string,
  headline: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
